import Cookies from 'js-cookie';
import { useQuery } from '@tanstack/react-query';
import { getMySiteWallet } from '../services/api/implementation/impl';
import { useApproverAccess } from './useApproverAccess';
import { siteWalletRoleFor } from '../../shared/utils/siteWalletAccess';

export { siteWalletRoleFor };

/**
 * The signed-in person's Site Wallet role: vertical and level from the session
 * cookies, owner-ness from GET /approvals/me. `userId` is for the "not your
 * own" checks (approving, marking paid).
 */
export function useSiteWalletRole() {
  const { isOwner } = useApproverAccess();
  return {
    ...siteWalletRoleFor({
      vertical: Cookies.get('userVertical'),
      level: Cookies.get('userDesignationLevel'),
      isOwner
    }),
    userId: Number(Cookies.get('userId')) || null
  };
}

/**
 * The signed-in holder's wallet. `data` is null when they have none, which is
 * what hides Operations → My Wallet. Never asked for anybody else.
 */
export function useMySiteWallet(enabled = true) {
  return useQuery({
    queryKey: ['siteWalletMe'],
    queryFn: getMySiteWallet,
    enabled,
    staleTime: 60 * 1000,
    retry: false
  });
}
